import { z } from 'zod';
import { errorMap } from 'zod-validation-error';

import { deepCopy, getErrorKeys, removeKeysFromObject } from '../optionsSchemaUtils';
import { PaymentInstructionsElementOptions } from './PaymentInstructionsElement';

const DISPLAY_MODES = ['full-screen', 'container'] as const;

export const PaymentInstructionsOptionsSchema = z.object({
  token: z.string().trim().min(1),
  paymentReference: z.string().trim().min(1),
  displayMode: z.enum(DISPLAY_MODES).optional()
});

export const parsePaymentInstructionsOptions = (options: PaymentInstructionsElementOptions) => {
  const mandatoryResult = PaymentInstructionsOptionsSchema.safeParse(options, { errorMap });
  const initialOptions = deepCopy(options);

  if (
    !mandatoryResult.success &&
    (mandatoryResult.error.flatten().fieldErrors['token'] ||
      mandatoryResult.error.flatten().fieldErrors['paymentReference'])
  ) {
    return { errors: mandatoryResult.error.errors };
  }

  const errorKeys = getErrorKeys(mandatoryResult.error?.errors || []);
  const sanitizedOptions = removeKeysFromObject(options, errorKeys);

  return !mandatoryResult.success
    ? {
        warnings: mandatoryResult.error.flatten().fieldErrors,
        options: sanitizedOptions as PaymentInstructionsElementOptions,
        initialOptions
      }
    : {
        options: mandatoryResult.data as PaymentInstructionsElementOptions,
        initialOptions
      };
};
